import {
  VerticalListResults,
  ProfileData,
  ClauseCheckSummaryData,
} from "../../common/common.model";
import { rulesAndThresholds } from "./constants";

export class UserTableData {
  count: number;
  previous: any;
  next: any;
  results: UserTableEntity[];

  constructor(obj: any) {
    this.count = obj?.count;
    this.previous = obj?.previous;
    this.next = obj?.next;
    this.results = obj?.results?.map((res: any) => new UserTableEntity(res));
  }
}

class UserTableEntity {
  name: string;
  email: string;
  roles: [];
  id: string;
  powerUser: boolean;
  picture: string;
  profileDetails: {};

  constructor(obj: any) {
    this.name = obj?.given_name + " " + obj?.family_name;
    this.email = obj?.email;
    this.roles = obj?.roles;
    this.picture = obj?.picture;
    this.id = obj?.id;

    this.powerUser = Boolean(obj?.is_superuser);

    this.profileDetails = {
      name: this.name,
      image: this.picture,
      isPowerUser: this.powerUser,
    };
  }
}

export class PromptModel {
  id: string;
  rules: { name: string; count: number; unit: string }[];
  feature: string;
  category: string;
  displayName: string;
  isEnabled: boolean;
  updated_by: ProfileData;
  vertical_id: string;
  severity?: string;
  isGlobal?: boolean;
  constructor(obj: any) {
    this.id = obj?.id || new Date().getTime().toString();
    this.rules = obj?.rules?.length > 0 ? obj?.sanitizer(obj?.rules) : [];
    this.feature = obj?.feature;
    this.category = obj?.category;
    this.displayName = obj?.display_name;
    this.isEnabled = obj?.is_enabled ?? true;
    this.updated_by = new ProfileData(obj?.updated_by);
    this.vertical_id = obj?.vertical;
    this.severity = obj?.severity;
    this.isGlobal = obj?.is_global;
  }
}
export class PromptModelForVerticalList {
  count: number;
  next: string;
  previous: string;
  results: VerticalListResults[];
  constructor(obj: any) {
    this.count = obj?.count || 0;
    this.next = obj?.next || null;
    this.previous = obj?.previous || null;
    this.results =
      obj?.results
        ?.filter((vertical: any) => vertical?.is_enabled)
        ?.map((result: any) => new VerticalListResults(result)) || [];
  }
}

export class PromptModelForClauseCheckData {
  status: boolean;
  clauseCheckSummaryList: ClauseCheckSummaryData[];
  constructor(obj: any) {
    this.status = obj?.status || false;
    this.clauseCheckSummaryList =
      obj?.data?.map((result: any) => new ClauseCheckSummaryData(result)) || [];
  }
}

export class PromptModelForContractReview extends PromptModel {
  labelRules: {}[];
  threshold: {}[];
  ruleDescription: string;
  manualPrompt: boolean;
  // Current AI-generated (or manually overridden) prompt text, used to pre-populate the override textarea.
  aiReviewPrompt: string | null;
  constructor(obj: any) {
    super(obj);
    this.labelRules = rulesAndThresholds?.[obj?.display_name]?.rules;
    this.threshold = rulesAndThresholds?.[obj?.display_name]?.threshold;
    this.ruleDescription = obj?.rules ?? "";
    this.manualPrompt = obj?.manual_prompt ?? false;
    this.aiReviewPrompt = obj?.ai_review_prompt ?? null;
  }
}
